<template>
  <!-- eslint-disable -->
  <v-container id="rfp-page" fluid tag="section">
    <v-row justify="center">
      <v-col cols="12">
        <base-material-card color="primary" class="px-5 py-3 cityDetailsContainer">
          <template v-slot:heading>
            <div class="display-2 font-weight-light">City Subscriber View</div>
            <div class="
                d-flex
                flex-row
                align-center
                justify-start
                subtitle-1
                font-weight-light
              ">
              <span>This shows the City Subscriber profile</span>
            </div>
          </template>
          <div>
            <v-overlay :value="overlay" opacity="1" color="white" z-index="0" absolute="absolute">
              <v-progress-circular indeterminate size="100" color="primary">
              </v-progress-circular>
            </v-overlay>
          </div>
          <v-card-text>
            <v-row class="d-flex flex-row align-start justify-space-between" v-if="details">
              <!-- city details details -->
              <v-col cols="12" class="px-0">
                <v-row class="px-0">
                  <v-col cols="12">
                    <h3 class="headline text-left">City Details</h3>
                  </v-col>
                </v-row>
                <!-- individual row for city subscriber details -->
                <v-row class="px-0">
                  <v-col cols="4">
                    <span class="subtitle-1 text-left">City Name:</span>
                  </v-col>
                  <v-col cols="8">
                    <span class="subtitle-1 text-left" v-if="details.user.cityName">{{ details.user.cityName }}</span>
                    <span class="subtitle-1 text-left platinum--text text--darken-3" v-else>n/a</span>
                  </v-col>
                </v-row>
                <!-- end of individual row for city subscriber details -->
                <!-- individual row for city subscriber details -->
                <v-row class="px-0">
                  <v-col cols="4">
                    <span class="subtitle-1 text-left">Country:</span>
                  </v-col>
                  <v-col cols="8">
                    <span class="subtitle-1 text-left" v-if="details.user.country">{{ details.user.country }}</span>
                    <span class="subtitle-1 text-left platinum--text text--darken-3" v-else>n/a</span>
                  </v-col>
                </v-row>
                <!-- end of individual row for city details -->
                <!-- individual row for city details -->
                <v-row class="px-0">
                  <v-col cols="4">
                    <span class="subtitle-1 text-left">City's Official Website:</span>
                  </v-col>
                  <v-col cols="8">
                    <v-tooltip bottom v-if="details.profile && details.profile.website">
                      <template v-slot:activator="{ on }">
                        <span class="subtitle-1 text-left" v-on="on">
                          <a :href="validateUrl(details.profile.website)" target="_blank">{{
                            validateUrl(details.profile.website) }}</a>
                        </span>
                      </template>
                      <span>
                        Visit
                        <b>
                          <i>{{ validateUrl(details.profile.website) }}</i>
                        </b>
                      </span>
                    </v-tooltip>
                    <span class="subtitle-1 text-left platinum--text text--darken-3" v-else>n/a</span>
                  </v-col>
                </v-row>
                <!-- end of individual row for city details -->
                <!-- individual row for city details -->
                <v-row class="px-0">
                  <v-col cols="4">
                    <span class="subtitle-1 text-left">Type of Representation:</span>
                  </v-col>
                  <v-col cols="8">
                    <span class="subtitle-1 text-left" v-if="details.user.type">{{ details.user.type }}</span>
                    <span class="subtitle-1 text-left platinum--text text--darken-3" v-else>n/a</span>
                  </v-col>
                </v-row>
                <!-- end of individual row for city details -->
                <!-- individual row for city details -->
                <v-row class="px-0">
                  <v-col cols="4">
                    <span class="subtitle-1 text-left">Proof of Representation:</span>
                  </v-col>
                  <v-col cols="8">
                    <v-chip class="proof-link ma-0 px-4" color="secondary" label text-color="white"
                      :href="details.profile.proof[0]" target="_blank" v-if="details.profile && details.profile.proof">
                      <span class="subtitle-1">Download</span>
                      <v-icon right>mdi-file-download</v-icon>
                    </v-chip>
                    <span class="subtitle-1 text-left platinum--text text--darken-3" v-else>n/a</span>
                  </v-col>
                </v-row>
                <!-- end of individual row for city details -->
                <!-- individual row for city details -->
                <v-row class="px-0">
                  <v-col cols="4">
                    <span class="subtitle-1 text-left">City Office Address:</span>
                  </v-col>
                  <v-col cols="8">
                    <span v-if="details.profile && details.profile.address" class="subtitle-1 text-left">{{
                      `${details.profile.address.street
                        ? details.profile.address.street
                        : ""
                      } ${details.profile.address.postalCode
                        ? `[${details.profile.address.postalCode}]`
                        : ""
                      } ${details.profile.address.city
                        ? `, ${details.profile.address.city}, `
                        : ""
                      }${details.profile.address.country
                        ? `${details.profile.address.country}`
                        : ""
                      }`
                    }}</span>
                    <span class="subtitle-1 text-left platinum--text text--darken-3" v-else>n/a</span>
                  </v-col>
                </v-row>
                <!-- end of individual row for city details -->
                <!-- individual row for venue details -->
                <v-row class="px-0">
                  <v-col cols="4">
                    <span class="subtitle-1 text-left">Social Media Channels:</span>
                  </v-col>
                  <v-col cols="8">
                    <v-row class="d-flex flex-row flex-wrap mx-0" v-if="
                      details.profile &&
                      details.profile.socialMedia.length > 0
                    ">
                      <v-col v-for="socialMedia in details.profile.socialMedia" :key="socialMedia._id"
                        v-show="socialMedia.link" class="py-0 pl-0 flex-grow-0">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on }">
                            <v-chip v-on="on" class="mr-2 mb-2" label :href="validateUrl(socialMedia.link)"
                              target="_blank" :color="getSocialColor(socialMedia.name)">
                              <font-awesome-icon :icon="['fab', socialMedia.icon]" class="mr-2" size="2x"
                                color="white" />
                              <span class="
                                  text-left
                                  caption
                                  text-capitalize
                                  white--text
                                ">{{ socialMedia.name }}</span>
                            </v-chip>
                          </template>
                          <span>{{ validateUrl(socialMedia.link) }}</span>
                        </v-tooltip>
                      </v-col>
                    </v-row>
                    <v-row class="d-flex flex-row mx-0" v-else>
                      <span class="
                          subtitle-1
                          text-left
                          platinum--text
                          text--darken-3
                        ">n/a</span>
                    </v-row>
                  </v-col>
                </v-row>
                <!-- end of individual row for city details -->
                <!-- individual row for city details -->
                <v-row class="px-0">
                  <v-col cols="4">
                    <span class="subtitle-1 text-left">Main topic city specializes in:</span>
                  </v-col>
                  <v-col cols="8" v-if="details && details.topics && details.topics.topic[0]">
                    <v-row class="d-flex flex-row flex-wrap mx-0" v-if="details.topics.topic">
                      <v-chip class="mr-2 mb-2 grey--text" label v-for="(topic) in details.topics.topic">{{
                        topic
                      }}</v-chip>
                    </v-row>
                    <v-row class="mx-0" v-else>
                      <span class="
                          subtitle-1
                          text-left
                          platinum--text
                          text--darken-3
                        ">n/a</span>
                    </v-row>
                  </v-col>
                  <v-col cols="8" v-else>
                    <v-row class="mx-0">
                      <span class="
                          subtitle-1
                          text-left
                          platinum--text
                          text--darken-3
                        ">n/a</span>
                    </v-row>
                  </v-col>
                </v-row>
                <!-- end of individual row for city details -->
                <!-- individual row for city details -->
                <v-row class="px-0">
                  <v-col cols="4">
                    <span class="subtitle-1 text-left">Subtopics city specializes in:</span>
                  </v-col>
                  <v-col cols="8" v-if="
                    details &&
                    details.topics &&
                    details.topics.supTopic
                  ">
                    <v-row class="d-flex flex-row flex-wrap mx-0" v-if="details.topics.supTopic.length > 1">
                      <v-chip class="mr-2 mb-2 grey--text" label :key="index" v-for="(supTopic, index) in details.topics
                        .supTopic">{{ supTopic }}</v-chip>
                    </v-row>
                    <v-row class="mx-0" v-else>
                      <span class="
                          subtitle-1
                          text-left
                          platinum--text
                          text--darken-3
                        ">n/a</span>
                    </v-row>
                  </v-col>
                  <v-col cols="8" v-else>
                    <v-row class="mx-0">
                      <span class="
                          subtitle-1
                          text-left
                          platinum--text
                          text--darken-3
                        ">n/a</span>
                    </v-row>
                  </v-col>
                </v-row>
                <!-- end of individual row for city details -->
              </v-col>
              <!-- city rep. details -->
              <v-col cols="12" class="px-0">
                <v-row class="px-0">
                  <v-col cols="12">
                    <h3 class="headline text-left">
                      City (Representative) Details
                    </h3>
                  </v-col>
                </v-row>
                <!-- individual row for city rep. details -->
                <v-row class="px-0">
                  <v-col cols="4">
                    <span class="subtitle-1 text-left">Name:</span>
                  </v-col>
                  <v-col cols="8">
                    <span class="subtitle-1 text-left" v-if="details.user.name">{{ details.user.name }}</span>
                    <span class="subtitle-1 text-left platinum--text text--darken-3" v-else>n/a</span>
                  </v-col>
                </v-row>
                <!-- end of individual row for city rep. details -->
                <!-- individual row for city rep. details -->
                <v-row class="px-0">
                  <v-col cols="4">
                    <span class="subtitle-1 text-left">Email:</span>
                  </v-col>
                  <v-col cols="8">
                    <v-tooltip bottom v-if="details.user.email">
                      <template v-slot:activator="{ on }">
                        <span class="subtitle-1 text-left" v-on="on">
                          <a :href="`mailto:${details.user.email}`">{{
                            details.user.email
                          }}</a>
                        </span>
                      </template>
                      <span>
                        Send an email to
                        <b>{{ details.user.name }}</b> via
                        <b>
                          <i>{{ details.user.email }}</i>
                        </b>
                      </span>
                    </v-tooltip>
                    <span class="subtitle-1 text-left platinum--text text--darken-3" v-else>n/a</span>
                  </v-col>
                </v-row>
                <!-- end of individual row for city rep. details -->
                <!-- individual row for city rep. details -->
                <v-row class="px-0">
                  <v-col cols="4">
                    <span class="subtitle-1 text-left">Phone:</span>
                  </v-col>
                  <v-col cols="8">
                    <v-tooltip bottom v-if="
                      details.profile &&
                      details.profile.telephoneNo &&
                      details.profile.telephoneNo.no
                    ">
                      <template v-slot:activator="{ on }">
                        <span class="subtitle-1 text-left" v-on="on">
                          <a :href="`tel:+${details.profile.telephoneNo.code +
                            details.profile.telephoneNo.no
                            }`">{{
                              `+${details.profile.telephoneNo.code} ${details.profile.telephoneNo.no}`
                            }}</a>
                        </span>
                      </template>
                      <span>
                        Call
                        <b>{{ details.user.name }}</b> via
                        <b>
                          <i>{{
                            `+${details.profile.telephoneNo.code} ${details.profile.telephoneNo.no}`
                          }}</i>
                        </b>
                      </span>
                    </v-tooltip>
                    <span class="subtitle-1 text-left platinum--text text--darken-3" v-else>n/a</span>
                  </v-col>
                </v-row>
                <!-- end of individual row for city rep. details -->
                <!-- individual row for city rep. details -->
                <v-row class="px-0">
                  <v-col cols="4">
                    <span class="subtitle-1 text-left">Joined Date:</span>
                  </v-col>
                  <v-col cols="8">
                    <span class="subtitle-1 text-left" v-if="computedDateFormat">{{ computedDateFormat }}</span>
                    <span class="subtitle-1 text-left platinum--text text--darken-3" v-else>n/a</span>
                  </v-col>
                </v-row>
                <!-- end of individual row for city rep. details -->
              </v-col>
              <!-- city payment details -->
              <v-col cols="12" class="px-0">
                <v-row class="px-0">
                  <v-col cols="12">
                    <h3 class="headline text-left">City Payment Details</h3>
                  </v-col>
                </v-row>
                <!-- individual row for city details -->
                <v-row class="px-0">
                  <v-col cols="4">
                    <span class="subtitle-1 text-left">City Profile:</span>
                  </v-col>
                  <v-col cols="8">
                    <span class="subtitle-1 text-left primary--text" v-if="details.user.isAdvance">Advance
                      Profile</span>
                    <span class="subtitle-1 text-left secondary--text" v-else>Basic Profile</span>
                  </v-col>
                </v-row>
                <!-- end of individual row for city details -->
                <!-- individual row for city details -->
                <v-row class="px-0">
                  <v-col cols="4">
                    <span class="subtitle-1 text-left">City Approval State:</span>
                  </v-col>
                  <v-col cols="8">
                    <span class="subtitle-1 text-left success--text" v-if="details.user.isApproved">Approved</span>
                    <span class="subtitle-1 text-left warning--text" v-else>Pending/Rejected</span>
                  </v-col>
                </v-row>
                <!-- end of individual row for city details -->
              </v-col>
              <v-col cols="12" class="px-0">
                <v-row class="px-0">
                  <v-col cols="5">
                    <h3 class="headline text-left" style="margin-bottom: 20px;">Sustainability Certificates</h3>
                    <v-divider style="margin-bottom: 20px;"></v-divider>
                  </v-col>
                </v-row>
                <v-row class="px-0" v-for="(url, index) in sustainabilityDocs" :key="url" style="margin-bottom: -40px;">
                  <v-col cols="4">{{ index + 1 }} :- <a
                      :href="`https://conferli-storage.s3.amazonaws.com/sustainabilityCertificates/` + url"
                      target="_blank">{{ url
                      }}</a></v-col>
                  <v-col cols="2">
                    <v-btn icon color="red lighten-1" @click="removeCertificate(index)">
                      <font-awesome-icon :icon="['fas', 'trash']" />
                    </v-btn>
                  </v-col>
                </v-row>
                <h6 class="text-left" v-if="sustainabilityDocs.length < 1" style="margin-top: 25px;">Not uploaded yet!
                </h6>
              </v-col>

              <!-- Requested Features -->
              <v-col cols="12" class="px-0">
                <v-row class="px-0 py-5">
                  <v-col cols="5">
                    <h3 class="headline text-left" style="margin-bottom: 20px;">Requested Features</h3>
                  </v-col>
                </v-row>

                <h3 class="title text-left" style="margin-bottom: 20px;">Bureau Services</h3>

                <v-row class="px-0 align-center">
                  <v-col cols="4">
                    <span class="subtitle-1 text-left">Board Base:</span>
                  </v-col>
                  <v-col cols="2">
                    <v-switch class="text-center" v-model="quarterlyResearch"></v-switch>
                  </v-col>
                  <v-col cols="4">
                    <v-col cols="10" class="py-0">
                      <v-menu v-model="quarterlyResearchmenu" :close-on-content-click="false" :nudge-right="40"
                        transition="scale-transition" offset-y min-width="auto">
                        <template #activator="{ on, attrs }">
                          <v-text-field v-bind="attrs" v-on="on" style="margin-bottom: -30px;"
                            label="Select Expiry Date" outlined v-model="quarterlyResearchdate"></v-text-field>
                        </template>
                        <v-date-picker v-model="quarterlyResearchdate" no-title scrollable
                          :min="new Date().toISOString().substr(0, 10)"
                          @input="quarterlyResearchmenu = false"></v-date-picker>
                      </v-menu>
                    </v-col>
                  </v-col>
                </v-row>
                <v-row class="px-0 align-center">
                  <v-col cols="4">
                    <span class="subtitle-1 text-left">Event Booking:</span>
                  </v-col>
                  <v-col cols="2">
                    <v-switch class="text-center" v-model="eventBooking"></v-switch>
                  </v-col>
                  <v-col cols="4">
                    <v-col cols="10" class="py-0">
                      <v-menu v-model="eventBookingmenu" :close-on-content-click="false" :nudge-right="40"
                        transition="scale-transition" offset-y min-width="auto">
                        <template #activator="{ on, attrs }">
                          <v-text-field v-bind="attrs" v-on="on" style="margin-bottom: -30px" label="Select Expiry Date"
                            outlined v-model="eventBookingdate"></v-text-field>
                        </template>
                        <v-date-picker v-model="eventBookingdate" no-title scrollable
                          :min="new Date().toISOString().substr(0, 10)"
                          @input="eventBookingmenu = false"></v-date-picker>
                      </v-menu>
                    </v-col>
                  </v-col>
                </v-row>

                <h3 class="title text-left py-6" style="margin-bottom: 20px;">Profile</h3>

                <v-row class="px-0 align-center">
                  <v-col cols="4">
                    <span class="subtitle-1 text-left">Premium Listing Services:</span>
                  </v-col>
                  <v-col cols="2">
                    <v-switch class="text-center" v-model="premiumListing"></v-switch>
                  </v-col>
                  <v-col cols="4">
                    <v-col cols="10" class="py-0">
                      <v-menu v-model="premiumListingmenu" :close-on-content-click="false" :nudge-right="40"
                        transition="scale-transition" offset-y min-width="auto">
                        <template #activator="{ on, attrs }">
                          <v-text-field v-bind="attrs" v-on="on" style="margin-bottom: -30px;"
                            label="Select Expiry Date" outlined v-model="premiumListingdate"></v-text-field>
                        </template>
                        <v-date-picker v-model="premiumListingdate" no-title scrollable
                          :min="new Date().toISOString().substr(0, 10)"
                          @input="premiumListingmenu = false"></v-date-picker>
                      </v-menu>
                    </v-col>
                  </v-col>
                </v-row>
                <v-row class="px-0 align-center">
                  <v-col cols="4">
                    <span class="subtitle-1 text-left">Direct Contact:</span>
                  </v-col>
                  <v-col cols="2">
                    <v-switch class="text-center" v-model="directContact"></v-switch>
                  </v-col>
                  <v-col cols="4">
                    <v-col cols="10" class="py-0">
                      <v-menu v-model="directContactmenu" :close-on-content-click="false" :nudge-right="40"
                        transition="scale-transition" offset-y min-width="auto">
                        <template #activator="{ on, attrs }">
                          <v-text-field v-bind="attrs" v-on="on" style="margin-bottom: -30px;"
                            label="Select Expiry Date" outlined v-model="directContactdate"></v-text-field>
                        </template>
                        <v-date-picker v-model="directContactdate" no-title scrollable
                          :min="new Date().toISOString().substr(0, 10)"
                          @input="directContactmenu = false"></v-date-picker>
                      </v-menu>
                    </v-col>
                  </v-col>
                </v-row>
                <v-row class="px-0 align-center">
                  <v-col cols="4">
                    <span class="subtitle-1 text-left">Open Tenders:</span>
                  </v-col>
                  <v-col cols="2">
                    <v-switch class="text-center" v-model="openTenders"></v-switch>
                  </v-col>
                  <v-col cols="4">
                    <v-col cols="10" class="py-0">
                      <v-menu v-model="openTendersmenu" :close-on-content-click="false" :nudge-right="40"
                        transition="scale-transition" offset-y min-width="auto">
                        <template #activator="{ on, attrs }">
                          <v-text-field v-bind="attrs" v-on="on" style="margin-bottom: -30px;"
                            label="Select Expiry Date" outlined v-model="openTendersdate"></v-text-field>
                        </template>
                        <v-date-picker v-model="openTendersdate" no-title scrollable
                          :min="new Date().toISOString().substr(0, 10)"
                          @input="openTendersmenu = false"></v-date-picker>
                      </v-menu>
                    </v-col>
                  </v-col>
                </v-row>
                <v-row class="px-0 align-center">
                  <v-col cols="4">
                    <span class="subtitle-1 text-left">Success Story/Case Studies:</span>
                  </v-col>
                  <v-col cols="2">
                    <v-switch class="text-center" v-model="caseStudies"></v-switch>
                  </v-col>
                  <v-col cols="4">
                    <v-col cols="10" class="py-0">
                      <v-menu v-model="caseStudiesmenu" :close-on-content-click="false" :nudge-right="40"
                        transition="scale-transition" offset-y min-width="auto">
                        <template #activator="{ on, attrs }">
                          <v-text-field v-bind="attrs" v-on="on" style="margin-bottom: -30px;"
                            label="Select Expiry Date" outlined v-model="caseStudiesdate"></v-text-field>
                        </template>
                        <v-date-picker v-model="caseStudiesdate" no-title scrollable
                          :min="new Date().toISOString().substr(0, 10)"
                          @input="caseStudiesmenu = false"></v-date-picker>
                      </v-menu>
                    </v-col>
                  </v-col>
                </v-row>
                <v-row class="px-0 align-center">
                  <v-col cols="4">
                    <span class="subtitle-1 text-left">Dedicated City Pitch:</span>
                  </v-col>
                  <v-col cols="2">
                    <v-switch class="text-center" v-model="cityPitch"></v-switch>
                  </v-col>
                  <v-col cols="4">
                    <v-col cols="10" class="py-0">
                      <v-menu v-model="cityPitchmenu" :close-on-content-click="false" :nudge-right="40"
                        transition="scale-transition" offset-y min-width="auto">
                        <template #activator="{ on, attrs }">
                          <v-text-field v-bind="attrs" v-on="on" style="margin-bottom: -30px;"
                            label="Select Expiry Date" outlined v-model="cityPitchdate"></v-text-field>
                        </template>
                        <v-date-picker v-model="cityPitchdate" no-title scrollable
                          :min="new Date().toISOString().substr(0, 10)" @input="cityPitchmenu = false"></v-date-picker>
                      </v-menu>
                    </v-col>
                  </v-col>
                </v-row>
                <v-row class="px-0 align-center">
                  <v-col cols="4">
                    <span class="subtitle-1 text-left">Destination Videos:</span>
                  </v-col>
                  <v-col cols="2">
                    <v-switch class="text-center" v-model="destinationVideos"></v-switch>
                  </v-col>
                  <v-col cols="4">
                    <v-col cols="10" class="py-0">
                      <v-menu v-model="destinationVideosmenu" :close-on-content-click="false" :nudge-right="40"
                        transition="scale-transition" offset-y min-width="auto">
                        <template #activator="{ on, attrs }">
                          <v-text-field v-bind="attrs" v-on="on" style="margin-bottom: -30px;"
                            label="Select Expiry Date" outlined v-model="destinationVideosdate"></v-text-field>
                        </template>
                        <v-date-picker v-model="destinationVideosdate" no-title scrollable
                          :min="new Date().toISOString().substr(0, 10)"
                          @input="destinationVideosmenu = false"></v-date-picker>
                      </v-menu>
                    </v-col>
                  </v-col>
                </v-row>

              </v-col>

              <v-col cols="12" class="px-0" style="margin-top: 20px">
                <v-row class="px-0">
                  <v-col cols="5">
                    <h3 class="headline text-left">Destination Support Package</h3>
                  </v-col>
                </v-row>

                <v-row class="px-0 mt-4 align-start">
                  <v-col cols="4" class="py-4">
                    <span class="subtitle-1 text-left">Destination offers support:</span>
                  </v-col>
                  <v-col cols="8">
                    <v-col cols="12" md="8" class="pt-4 pb-8">
                      <v-select :items="['Yes', 'No', 'Unknown']" v-model="supportForm.destinationOffersSupport"
                        outlined dense hide-details>
                        <template v-slot:selection="{ item }">
                          <div style="width: 100%; text-align: right; padding-right: 20px;">
                            {{ item }}
                          </div>
                        </template>

                        <template v-slot:item="{ item, on, attrs }">
                          <v-list-item v-bind="attrs" v-on="on">
                            <v-list-item-content>
                              <v-list-item-title style="text-align: right; padding-right: 20px;">
                                {{ item }}
                              </v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                        </template>

                      </v-select>
                    </v-col>
                  </v-col>

                  <template v-if="supportForm.destinationOffersSupport === 'Yes'">
                    <v-col cols="4" class="py-1">
                      <span class="subtitle-1 text-left">Type of support available:</span>
                    </v-col>
                    <v-col cols="8">
                      <v-col cols="12" md="8" class="py-1">
                        <v-select class="mb-6" :items="supportTypeMap" v-model="selectedSupportTypes" item-text="label"
                          item-value="key" label="Select here" outlined dense multiple small-chips deletable-chips
                          hide-details>
                          <template v-slot:selection="{ item }">
                            <v-chip small close class="ma-1"
                              @click:close="selectedSupportTypes = selectedSupportTypes.filter(i => i !== item.key)">
                              {{ item.label }}
                            </v-chip>
                          </template>
                        </v-select>

                        <v-text-field v-if="selectedSupportTypes.includes('otherSupport')"
                          :value="supportForm.otherSupportDescription"
                          @input="handleWordLimitInput('otherSupportDescription', 100, $event)"
                          label="Describe other support (Max 100 Words)" outlined dense class="mt-8"
                          :error-messages="validationErrors.otherSupportDescription" counter>
                          <template v-slot:counter>
                            <span style="font-size: 12px;">{{ getWordCount(supportForm.otherSupportDescription) }}/100
                              words</span>
                          </template>
                        </v-text-field>

                        <v-textarea v-if="selectedSupportTypes.includes('directFinancialSupport')"
                          :value="supportForm.directFinancialSupportDescription"
                          @input="handleWordLimitInput('directFinancialSupportDescription', 150, $event)"
                          label="Detailed Funding & Grants Information (Max 150 Words)" outlined dense rows="4"
                          :error-messages="validationErrors.directFinancialSupportDescription" counter>
                          <template v-slot:counter>
                            <span style="font-size: 12px;">{{
                              getWordCount(supportForm.directFinancialSupportDescription) }}/150 words</span>
                          </template>
                        </v-textarea>
                      </v-col>
                    </v-col>

                    <v-col cols="4" class="py-1">
                      <span class="subtitle-1 text-left">Who can apply:</span>
                    </v-col>
                    <v-col cols="8">
                      <v-col cols="12" md="8" class="py-1">
                        <v-textarea :value="supportForm.whoCanApply"
                          @input="handleWordLimitInput('whoCanApply', 100, $event)"
                          placeholder="Write here (Max 100 Words)" outlined rows="4"
                          :error-messages="validationErrors.whoCanApply" counter>
                          <template v-slot:counter>
                            <span style="font-size: 12px;">{{ getWordCount(supportForm.whoCanApply) }}/100 words</span>
                          </template>
                        </v-textarea>
                      </v-col>
                    </v-col>

                    <v-col cols="4" class="py-1">
                      <span class="subtitle-1 text-left">When to apply:</span>
                    </v-col>
                    <v-col cols="8">
                      <v-col cols="12" md="8" class="py-1">
                        <v-textarea :value="supportForm.whenCanApply"
                          @input="handleWordLimitInput('whenCanApply', 50, $event)"
                          placeholder="Write here (Max 50 Words)" outlined rows="4"
                          :error-messages="validationErrors.whenCanApply" counter>
                          <template v-slot:counter>
                            <span style="font-size: 12px;">{{ getWordCount(supportForm.whenCanApply) }}/50 words</span>
                          </template>
                        </v-textarea>
                      </v-col>
                    </v-col>

                    <v-col cols="4" class="py-1">
                      <span class="subtitle-1 text-left">How to apply:</span>
                    </v-col>
                    <v-col cols="8">
                      <v-col cols="12" md="8" class="py-1">
                        <v-textarea :value="supportForm.howToApply"
                          @input="handleWordLimitInput('howToApply', 50, $event)"
                          placeholder="Write here (Max 50 Words)" outlined rows="4"
                          :error-messages="validationErrors.howToApply" counter>
                          <template v-slot:counter>
                            <span style="font-size: 12px;">{{ getWordCount(supportForm.howToApply) }}/50 words</span>
                          </template>
                        </v-textarea>
                      </v-col>
                    </v-col>
                    <v-col cols="4" class="py-1">
                      <span class="subtitle-1 text-left">Relevant Document (PDF):</span>
                      <p style="font-size: 10px;">Uploading new documents will replace the existing list.
                        If you wish to keep the exsisting documents and add new documents,
                        please download the existing documents first and upload them with the new ones.</p>
                    </v-col>
                    <v-col cols="8">
                      <v-col cols="12" md="8" class="py-1">
                        <v-file-input v-model="files" accept="application/pdf" label="Choose PDF file" outlined dense
                          multiple chips :loading="uploadInProgress" prepend-icon="" append-icon="mdi-file-pdf-box"
                          placeholder="Select your document" @change="uploadDocs"></v-file-input>

                        <div v-if="supportForm.pdfLinks && supportForm.pdfLinks.length > 0" class="mt-2">
                          <p class="caption font-weight-bold mb-1">Uploaded Documents:</p>
                          <v-chip v-for="(url, index) in supportForm.pdfLinks" :key="index" small class="ma-1"
                            color="success" outlined>
                            <a :href="url" target="_blank" style="text-decoration: none; color: inherit;" download>
                              <v-icon left small color="success">mdi-download</v-icon>
                              Document {{ index + 1 }}
                            </a>

                            <v-icon right small @click="removePdf(index)" color="red">
                              mdi-close-circle
                            </v-icon>
                          </v-chip>
                        </div>
                      </v-col>
                    </v-col>

                    <v-col cols="4" class="py-1">
                      <span class="subtitle-1 text-left">Website Link:</span>
                    </v-col>
                    <v-col cols="8">
                      <v-col cols="12" md="8" class="py-1">
                        <v-text-field v-model="supportForm.websiteLink" label="https://example.com" outlined dense
                          placeholder="Enter website URL" :error-messages="validationErrors.websiteLink"></v-text-field>
                      </v-col>
                    </v-col>

                    <v-col cols="4" class="py-1">
                      <span class="subtitle-1 text-left">Eligibility Criteria:</span>
                    </v-col>
                    <v-col cols="8">
                      <v-col cols="12" md="8" class="py-1">
                        <v-select class="mb-6" :items="eligibilityMap" v-model="selectedEligibility" item-text="label"
                          item-value="key" label="Select here" outlined dense multiple small-chips deletable-chips
                          hide-details>
                          <template v-slot:selection="{ item }">
                            <v-chip small close class="ma-1"
                              @click:close="selectedEligibility = selectedEligibility.filter(i => i !== item.key)">
                              {{ item.label }}
                            </v-chip>
                          </template>
                        </v-select>

                        <v-text-field v-if="selectedEligibility.includes('otherEligibility')"
                          :value="supportForm.otherEligibilityDescription"
                          @input="handleWordLimitInput('otherEligibilityDescription', 100, $event)"
                          label="Describe other eligibility (Max 100 Words)" outlined dense class="mt-8"
                          :error-messages="validationErrors.otherEligibilityDescription" counter>
                          <template v-slot:counter>
                            <span style="font-size: 12px;">{{ getWordCount(supportForm.otherEligibilityDescription)
                              }}/100 words</span>
                          </template>
                        </v-text-field>
                      </v-col>
                    </v-col>
                  </template>

                  <v-col cols="4"></v-col>
                  <v-col cols="8">
                    <v-col cols="12" md="8" class="d-flex justify-end pr-0" style="min-height: 50px;">
                      <v-fade-transition>
                        <v-btn v-if="hasSupportChanges" color="secondary" class="ma-0 mr-3"
                          @click="updateSupportPackage" :loading="isSupportLoading" :disabled="!isFormValid">
                          Update Destination Support Package
                        </v-btn>
                      </v-fade-transition>
                    </v-col>
                  </v-col>

                </v-row>
              </v-col>

              <v-col cols="12" class="px-0" style="margin-top: 20px">
                <v-row class="px-0">
                  <v-col cols="5">
                    <h3 class="headline text-left">
                      Update Representative Account
                    </h3>
                    <v-divider></v-divider>
                    <v-row class="px-0">
                      <v-col cols="10" style="margin-top: 20px">
                        <v-text-field style="margin-bottom: -40px" type="text" label="City Subscriber Name" outlined
                          v-model="name"></v-text-field>
                      </v-col>
                      <v-col cols="10">
                        <v-text-field style="margin-bottom: -40px" type="text" label="Email" outlined
                          v-model="email"></v-text-field>
                      </v-col>
                      <v-col cols="10">
                        <v-text-field style="margin-bottom: -40px" :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                          :type="show ? 'text' : 'password'" v-model="password" label="New Password" outlined
                          @click:append="show = !show" :error-messages="errorPassword"></v-text-field>
                      </v-col>
                      <v-col cols="10">
                        <v-btn block style="background-color: #35a7ff;" @click="dialog = true">
                          <v-icon left dark>
                            mdi-card-account-details
                          </v-icon>
                          Update Representative Account
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card-text>
        </base-material-card>
      </v-col>
    </v-row>
    <v-dialog v-model="dialog" max-width="600px">
      <v-card height="45vh" style="overflow-y: scroll;padding-right: 10px;padding-left: 10px;padding-top: 20px">
        <v-card-title class="px-2 px-sm-6">
          <v-row class="pb-3">
            <v-col cols="8" lg="10" class="d-flex flex-column justify-center align-start py-0">
              <h2 class="headline text-left">Please confirm</h2>
            </v-col>
            <v-col cols="4" lg="2" class="d-flex flex-column justify-center align-end py-0">
              <v-btn class="dialog-close-btn" icon color="grey lighten-1" @click="dialog = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-title>
        <v-card-text>
          <v-row v-if="details.user.email !== email || details.user.name !== name || password !== ''">
            <v-col cols="6" md="6">
              <span class="text-left caption text-capitalize red--text">Current</span>
              <br />
              <span class="text-left caption text-capitalize black--text" v-if="details.user.name !== name">Name :- {{
                details.user.name }}</span>
              <v-divider></v-divider>
              <span class="text-left caption text-capitalize black--text" v-if="details.user.email !== email">Email :-
                {{
                  details.user.email.toLowerCase()
                }}</span>
              <v-divider></v-divider>
              <span class="text-left caption text-capitalize black--text" v-if="password !== ''">Password :-
                hidden</span>
            </v-col>
            <v-col cols="6" md="6">
              <span class="text-left caption text-capitalize green--text">New</span>
              <br />
              <span class="text-left caption text-capitalize black--text" v-if="details.user.name !== name">Name :- {{
                name
              }}</span>
              <v-divider></v-divider>
              <span class="text-left caption text-capitalize black--text" v-if="details.user.email !== email">Email :-
                {{
                  email
                }}</span>
              <v-divider></v-divider>
              <span class="text-left caption text-capitalize black--text" v-if="password !== ''">Password :- {{
                password === '' ? 'Not Changed!' : password
              }}</span>
            </v-col>
          </v-row>
          <v-row v-else style="text-align: center">
            <span style="text-align: center;width: 100%;margin-top: 10vh"
              class="text-center caption text-capitalize grey--text font-weight-bold">There is no changes to
              update!</span>
          </v-row>
        </v-card-text>
        <v-card-actions class="px-6"
          v-if="details.user.email !== email || details.user.name !== name || password !== ''">
          <v-row class="d-flex flex-column-reverse flex-sm-row align-center justify-space-between mx-0">
            <v-col cols="12" sm="3" class="d-flex flex-column align-center align-sm-start px-0">
              <v-btn class="px-8" color="secondary" @click="dialog = false" tile outlined depressed bottom>
                Cancel
              </v-btn>
            </v-col>
            <v-col cols="12" sm="3" class="d-flex flex-column align-center align-sm-end px-0"
              v-if="details.user.email !== email || details.user.name !== name || password !== ''">
              <v-btn class="px-8 mx-0" color="secondary" tile depressed bottom right @click="updateProfile">
                Confirm
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import Apicalls from "../../../services/login.service";
import { mapGetters } from "vuex";
import CitySubApi from "../../../services/citySubscribers.service";
export default {
  name: "CitySubView",
  data() {
    return {
      dialog: false,
      details: null,
      overlay: true,
      errorPassword: null,
      password: null,
      email: null,
      name: null,
      show: false,
      quarterlyResearch: false,
      eventBooking: false,
      premiumListing: false,
      directContact: false,
      openTenders: false,
      caseStudies: false,
      cityPitch: false,
      destinationVideos: false,
      quarterlyResearchmenu: false,
      eventBookingmenu: false,
      premiumListingmenu: false,
      directContactmenu: false,
      openTendersmenu: false,
      caseStudiesmenu: false,
      cityPitchmenu: false,
      destinationVideosmenu: false,
      quarterlyResearchdate: '',
      eventBookingdate: '',
      premiumListingdate: '',
      directContactdate: '',
      openTendersdate: '',
      caseStudiesdate: '',
      cityPitchdate: '',
      destinationVideosdate: '',
      staticErrorMessages: {
        email: {
          isEmpty: "Email Address cannot be empty"
        },
        password: {
          isEmpty: "Password cannot be empty"
        }
      },
      sustainabilityDocs: [],
      sustainabilityDocLinks: [],

      // Support Package Data
      isSupportLoading: false,
      selectedSupportTypes: [],
      selectedEligibility: [],
      originalSupportSnapshot: null,
      supportForm: {
        destinationOffersSupport: 'Unknown',
        whoCanApply: "",
        whenCanApply: "",
        howToApply: "",
        otherSupportDescription: "",
        otherEligibilityDescription: "",
        directFinancialSupportDescription: "",
        websiteLink: "",
        pdfLinks: "",
      },
      validationErrors: {
        otherSupportDescription: '',
        directFinancialSupportDescription: '',
        whoCanApply: '',
        whenCanApply: '',
        howToApply: '',
        otherEligibilityDescription: '',
      },
      supportTypeMap: [
        { label: "Sponsorship", key: "sponsorship" },
        { label: "Direct financial support", key: "directFinancialSupport" },
        { label: "Free public transport", key: "freePublicTransport" },
        { label: "In-kind support", key: "inKindSupport" },
        { label: "Branding & Marketing", key: "brandingAndMarketing" },
        { label: "Bid support", key: "bidSupport" },
        { label: "Logistical assistance (permit, visa etc.)", key: "logisticalAssistance" },
        { label: "Delegate boosting", key: "delegateBoosting" },
        { label: "Sustainability support", key: "sustainabilitySupport" },
        { label: "Legacy support", key: "legacySupport" },
        { label: "Support on Impact measurement", key: "impactMeasurement" },
        { label: "Partnership facilitation to connect organizers with local stakeholders for sustainability or legacy initiatives", key: "partnershipFacilitation" },
        { label: "Other", key: "otherSupport" },
      ],
      eligibilityMap: [
        { label: "Type of event", key: "typeOfEvent" },
        { label: "Delegate numbers", key: "delegateNumbers" },
        { label: "Room nights generated", key: "roomNightsGenerated" },
        { label: "Sector alignment", key: "sectorAlignment" },
        { label: "Government priorities", key: "governmentPriorities" },
        { label: "Local host involvement", key: "localHostInvolvement" },
        { label: "Seasonality", key: "seasonality" },
        { label: "Contribution to sustainability", key: "contributionToSustainability" },
        { label: "Contribution to social objectives", key: "contributionToSocialObjectives" },
        { label: "Other", key: "otherEligibility" },
      ],
      uploadInProgress: false,
      files: [],
    };
  },
  computed: {
    ...mapGetters({
      email: "getUserEmail",
    }),
    computedDateFormat() {
      return this.details.user.created_at.split("T")[0];
    },
    hasSupportChanges() {
      if (!this.originalSupportSnapshot) return false;
      return this.originalSupportSnapshot !== this.getSupportSnapshot();
    },
    isFormValid() {
      // Check if "Other" is selected in support types and field is empty
      if (this.selectedSupportTypes.includes('otherSupport') && !this.supportForm.otherSupportDescription.trim()) {
        return false;
      }

      // Check if "Direct financial support" is selected in support types and field is empty
      if (this.selectedSupportTypes.includes('directFinancialSupport') && !this.supportForm.directFinancialSupportDescription.trim()) {
        return false;
      }

      // Check if "Other" is selected in eligibility and field is empty
      if (this.selectedEligibility.includes('otherEligibility') && !this.supportForm.otherEligibilityDescription.trim()) {
        return false;
      }

      // Check if any validation errors exist
      for (let key in this.validationErrors) {
        if (this.validationErrors[key]) {
          return false;
        }
      }

      return true;
    }
  },
  mounted() {
    this.initFn();
  },
  watch: {
    premiumListing(val) {
      this.updateFeatureEnableDisable("premiumListingServices", "premiumListingServicesExp", val, this.premiumListingdate);
    },
    directContact(val) {
      this.updateFeatureEnableDisable("enableDirectContact", "enableDirectContactExp", val, this.directContactdate);
    },
    quarterlyResearch(val) {
      this.updateFeatureEnableDisable("quarterlyResearch", "quarterlyResearchExp", val, this.quarterlyResearchdate);
    },
    openTenders(val) {
      this.updateFeatureEnableDisable("enableOpenTender", "enableOpenTenderExp", val, this.openTendersdate);
    },
    destinationVideos(val) {
      this.updateFeatureEnableDisable("destinationVideos", "destinationVideosExp", val, this.destinationVideosdate);
    },
    caseStudies(val) {
      this.updateFeatureEnableDisable("caseStudies", "caseStudiesExp", val, this.caseStudiesdate);
    },
    eventBooking(val) {
      this.updateFeatureEnableDisable("eventBooking", "eventBookingExp", val, this.eventBookingdate);
    },
    cityPitch(val) {
      this.updateFeatureEnableDisable("dedicatedCityPitch", "dedicatedCityPitchExp", val, this.cityPitchdate);
    },
    premiumListingdate(val) {
      this.updateFeatureEnableDisable("premiumListingServices", "premiumListingServicesExp", true, val);
    },
    directContactdate(val) {
      this.updateFeatureEnableDisable("enableDirectContact", "enableDirectContactExp", true, val);
    },
    quarterlyResearchdate(val) {
      this.updateFeatureEnableDisable("quarterlyResearch", "quarterlyResearchExp", true, val);
    },
    openTendersdate(val) {
      this.updateFeatureEnableDisable("enableOpenTender", "enableOpenTenderExp", true, val);
    },
    destinationVideosdate(val) {
      this.updateFeatureEnableDisable("destinationVideos", "destinationVideosExp", true, val);
    },
    caseStudiesdate(val) {
      this.updateFeatureEnableDisable("caseStudies", "caseStudiesExp", true, val);
    },
    eventBookingdate(val) {
      this.updateFeatureEnableDisable("eventBooking", "eventBookingExp", true, val);
    },
    cityPitchdate(val) {
      this.updateFeatureEnableDisable("dedicatedCityPitch ", "dedicatedCityPitchExp", true, val);
    },
    selectedSupportTypes(val) {
      // Validate "Other" field when selection changes
      if (val.includes('otherSupport')) {
        this.validateRequiredField('otherSupportDescription');
      } else {
        this.validationErrors.otherSupportDescription = '';
      }

      // Validate "Direct financial support" field when selection changes
      if (val.includes('directFinancialSupport')) {
        this.validateRequiredField('directFinancialSupportDescription');
      } else {
        this.validationErrors.directFinancialSupportDescription = '';
      }
    },
    selectedEligibility(val) {
      // Validate "Other" field when selection changes
      if (val.includes('otherEligibility')) {
        this.validateRequiredField('otherEligibilityDescription');
      } else {
        this.validationErrors.otherEligibilityDescription = '';
      }
    },
  },
  methods: {
    removePdf(index) {
      this.supportForm.pdfLinks.splice(index, 1);

      // Optional: Send snackbar notification
      this.$store.dispatch("setSnackbarMessage", {
        snackBarText: "Document removed from list",
        snackBarColor: "info"
      });
    },
    uploadDocs() {
      if (!this.files || this.files.length === 0) return;

      this.uploadInProgress = true;
      var formData = new FormData();

      for (let i = 0; i < this.files.length; i++) {
        formData.append(`file_${i}`, this.files[i]);
      }

      CitySubApi.UploadOtherDocuments(formData)
        .then((res) => {
          if (!this.supportForm.pdfLinks) {
            this.$set(this.supportForm, 'pdfLinks', []);
          }

          this.supportForm.pdfLinks = [];
          res.data.content.forEach(url => {
            this.supportForm.pdfLinks.push(url);
          });

          let payload = {
            snackBarText: "Document uploaded successfully",
            snackBarColor: "success"
          };
          this.$store.dispatch("setSnackbarMessage", payload);
        })
        .catch((err) => {
          console.error(err);
          let payload = {
            snackBarText: "Upload failed",
            snackBarColor: "error"
          };
          this.$store.dispatch("setSnackbarMessage", payload);
        })
        .finally(() => {
          this.uploadInProgress = false;
        });
    },
    initFn(showOverlay = true) {
      this.overlay = showOverlay;
      let payload = {
        // email: this.email
        email: localStorage.getItem("setUserEmail"),
      };
      Apicalls.getDetails(payload)
        .then((res) => {
          // console.log(JSON.stringify(res.data.content));
          this.details = res.data.content;
          this.overlay = false;
          this.name = this.details.user.name;
          this.email = this.details.user.email;
          this.password = '';
          this.sustainabilityCertificates;
          this.details.topics.sustainabilityCertificates.forEach(element => {
            try {
              this.sustainabilityDocLinks.push(element);
              this.sustainabilityDocs.push(decodeURIComponent(element.split("sustainabilityCertificates/")[1].replace(/%20/g, ' ').replace(/%28/g, '(').replace(/%29/g, ')')))
            } catch (e) {
              console.log('sus certificate replace err')
            }
          });

          this.initSupportData();
          this.updateFromDB()
        })
        .catch();
      // this.updateFromDB()
    },

    // Word Limit Methods 
    handleWordLimitInput(field, maxWords, value) {
      const wordCount = this.getWordCount(value);

      // If word count exceeds limit, don't update and show error
      if (wordCount > maxWords) {
        this.validationErrors[field] = `The maximum limit is ${maxWords} words. You have entered ${wordCount} words`;
        return; // Don't update the field
      }

      // Clear error and update field
      this.validationErrors[field] = '';
      this.supportForm[field] = value;

      // Validate required fields for "Other" options
      this.validateRequiredField(field);
    },

    validateRequiredField(field) {
      if (field === 'otherSupportDescription' && this.selectedSupportTypes.includes('otherSupport')) {
        if (!this.supportForm.otherSupportDescription.trim()) {
          this.validationErrors.otherSupportDescription = 'This field is required when "Other" is selected';
        } else {
          this.validationErrors.otherSupportDescription = '';
        }
      }

      if (field === 'directFinancialSupportDescription' && this.selectedSupportTypes.includes('directFinancialSupport')) {
        if (!this.supportForm.directFinancialSupportDescription.trim()) {
          this.validationErrors.directFinancialSupportDescription = 'This field is required when "Direct financial support" is selected';
        } else {
          this.validationErrors.directFinancialSupportDescription = '';
        }
      }

      if (field === 'otherEligibilityDescription' && this.selectedEligibility.includes('otherEligibility')) {
        if (!this.supportForm.otherEligibilityDescription.trim()) {
          this.validationErrors.otherEligibilityDescription = 'This field is required when "Other" is selected';
        } else {
          this.validationErrors.otherEligibilityDescription = '';
        }
      }
    },

    getWordCount(value) {
      if (!value) return 0;
      return value.trim().split(/\s+/).filter(word => word.length > 0).length;
    },

    getSupportSnapshot() {
      return JSON.stringify({
        form: this.supportForm,
        types: [...this.selectedSupportTypes].sort(),
        eligibility: [...this.selectedEligibility].sort(),
        support: this.supportForm.destinationOffersSupport
      });
    },

    initSupportData() {
      const src = this.details.topics || this.details.profile || {};

      if (!src) return;

      this.supportForm.destinationOffersSupport = src.destinationOffersSupport || 'Unknown';
      this.supportForm.whoCanApply = src.whoCanApply || "";
      this.supportForm.whenCanApply = src.whenCanApply || "";
      this.supportForm.howToApply = src.howToApply || "";
      this.supportForm.websiteLink = src.websiteLink || "";
      this.supportForm.pdfLinks = src.pdfLinks || [];
      this.supportForm.otherSupportDescription = src.otherSupportDescription || "";
      this.supportForm.otherEligibilityDescription = src.otherEligibilityDescription || "";
      this.supportForm.directFinancialSupportDescription = src.directFinancialSupportDescription || "";

      this.selectedSupportTypes = [];
      this.supportTypeMap.forEach(item => {
        if (src[item.key] === true || src[item.key] === "true") {
          this.selectedSupportTypes.push(item.key);
        }
      });

      this.selectedEligibility = [];
      this.eligibilityMap.forEach(item => {
        if (src[item.key] === true || src[item.key] === "true") {
          this.selectedEligibility.push(item.key);
        }
      });

      this.originalSupportSnapshot = this.getSupportSnapshot();
    },

    updateSupportPackage() {
      // Final validation before submit
      if (!this.isFormValid) {
        let snackbar = {
          snackBarText: "Please fix all validation errors before submitting",
          snackBarColor: "error",
        };
        this.$store.dispatch("notify/setSnackbarMessage", snackbar);
        return;
      }

      this.isSupportLoading = true;

      let payload = {
        _id: this.details.topics._id,
        ...this.supportForm,
      };

      this.supportTypeMap.forEach(item => payload[item.key] = false);
      this.eligibilityMap.forEach(item => payload[item.key] = false);

      this.selectedSupportTypes.forEach(key => payload[key] = true);
      this.selectedEligibility.forEach(key => payload[key] = true);

      CitySubApi.SetDirectSupportOptions(payload)
        .then(() => {
          let snackbar = {
            snackBarText: "Destination Support Package updated successfully",
            snackBarColor: "success",
          };
          this.$store.dispatch("notify/setSnackbarMessage", snackbar);

          this.originalSupportSnapshot = this.getSupportSnapshot();
          this.initFn(false);
        })
        .catch(() => {
          let snackbar = {
            snackBarText: "Error updating support package",
            snackBarColor: "error",
          };
          this.$store.dispatch("notify/setSnackbarMessage", snackbar);
        })
        .finally(() => {
          this.isSupportLoading = false;
        });
    },

    async updateFeatureEnableDisable(feature, featureExp, status, date) {
      this.isLoading = true;
      if (date === '' || date === 'N/A') {
        const today = new Date();
        today.setFullYear(today.getFullYear() + 1); // Add 1 year to the current year
        const formattedDate = today.toISOString().split("T")[0];
        date = formattedDate;
      }
      await CitySubApi.SetFeatureStatus(this.details.topics._id, status, date, feature, featureExp);
      // this.updateFromDB()
    },
    async updateFromDB() {
      this.isLoading = true;
      await CitySubApi.GetFeatureStatus(this.details.topics._id).then(res => {


        this.quarterlyResearch = res.data.features.quarterlyResearch === 'true' || res.data.features.quarterlyResearch === true ? true : false;
        if (!this.quarterlyResearch) {
          this.quarterlyResearchdate = '';
        } else {
          this.quarterlyResearchdate = res.data.features.quarterlyResearchExp;
        }
        this.eventBooking = res.data.features.eventBooking === 'true' || res.data.features.eventBooking === true ? true : false;
        if (!this.eventBooking) {
          this.eventBookingdate = '';
        } else {
          this.eventBookingdate = res.data.features.eventBookingExp;
        }
        this.caseStudies = res.data.features.caseStudies === 'true' || res.data.features.caseStudies === true ? true : false;
        if (!this.caseStudies) {
          this.caseStudiesdate = '';
        } else {
          this.caseStudiesdate = res.data.features.caseStudiesExp;
        }
        this.cityPitch = res.data.features.dedicatedCityPitch === 'true' || res.data.features.dedicatedCityPitch === true ? true : false;
        if (!this.cityPitch) {
          this.cityPitchdate = '';
        } else {
          this.cityPitchdate = res.data.features.dedicatedCityPitchExp;
        }
        this.destinationVideos = res.data.features.destinationVideos === 'true' || res.data.features.destinationVideos === true ? true : false;
        if (!this.destinationVideos) {
          this.destinationVideosdate = '';
        } else {
          this.destinationVideosdate = res.data.features.destinationVideosExp;
        }
        this.openTenders = res.data.features.enableOpenTender === 'true' || res.data.features.enableOpenTender === true ? true : false;
        if (!this.openTenders) {
          this.openTendersdate = '';
        } else {
          this.openTendersdate = res.data.features.enableOpenTenderExp;
        }
        this.premiumListing = res.data.features.premiumListingServices === 'true' || res.data.features.premiumListingServices === true ? true : false;
        if (!this.premiumListing) {
          this.premiumListingdate = '';
        } else {
          this.premiumListingdate = res.data.features.premiumListingServicesExp;
        }
        this.directContact = res.data.features.enableDirectContact === 'true' || res.data.features.enableDirectContact === true ? true : false;
        if (!this.directContact) {
          this.directContactdate = '';
        } else {
          this.directContactdate = res.data.features.enableDirectContactExp;
        }



      });
      // await CitySubApi.GetFeatureStatus("FEATURES.MEMBER_BOOKING").then(res => {
      //     try {
      //         this.eventBooking = res.data.details.status === 'true' || res.data.details.status === true ? true : false;
      //     } catch (e) {
      //         this.eventBooking = false;
      //     }
      // });await CitySubApi.GetFeatureStatus("FEATURES.EVENT_BOOKING").then(res => {
      //     try {
      //         this.caseStudies = res.data.details.status === 'true' || res.data.details.status === true ? true : false;
      //     } catch (e) {
      //         this.caseStudies = false;
      //     }
      // });
      // await CitySubApi.GetFeatureStatus("FEATURES.MEMBER_BOOKING").then(res => {
      //     try {
      //         this.cityPitch = res.data.details.status === 'true' || res.data.details.status === true ? true : false;
      //     } catch (e) {
      //         this.cityPitch = false;
      //     }
      // });await CitySubApi.GetFeatureStatus("FEATURES.EVENT_BOOKING").then(res => {
      //     try {
      //         this.destinationVideos = res.data.details.status === 'true' || res.data.details.status === true ? true : false;
      //     } catch (e) {
      //         this.destinationVideos = false;
      //     }
      // });
      // await CitySubApi.GetFeatureStatus("FEATURES.MEMBER_BOOKING").then(res => {
      //     try {
      //         this.openTenders = res.data.details.status === 'true' || res.data.details.status === true ? true : false;
      //     } catch (e) {
      //         this.openTenders = false;
      //     }
      // });
      // await CitySubApi.GetFeatureStatus("FEATURES.EVENT_BOOKING").then(res => {
      //     try {
      //         this.premiumListing = res.data.details.status === 'true' || res.data.details.status === true ? true : false;
      //     } catch (e) {
      //         this.premiumListing = false;
      //     }
      // });
      // await CitySubApi.GetFeatureStatus("FEATURES.MEMBER_BOOKING").then(res => {
      //     try {
      //         this.directContact = res.data.details.status === 'true' || res.data.details.status === true ? true : false;
      //     } catch (e) {
      //         this.directContact = false;
      //     }
      // });
      this.isLoading = false;
    },
    async removeCertificate(index) {
      const payload = {
        profile: this.details.user._id,
        url: this.sustainabilityDocLinks[index]
      }
      await CitySubApi.deleteSustainabilityCertificate(payload);
      this.sustainabilityDocLinks = []
      this.sustainabilityDocs = []
      await this.initFn();
    },
    getSocialColor(name) {
      if (name == "LinkedIn") {
        return "#0a66c2";
      } else if (name == "Twitter") {
        return "#1da1f2";
      } else if (name == "Youtube") {
        return "#ff0000";
      } else if (name == "Instagram") {
        return "#f00075";
      } else if (name == "Vimeo") {
        return "#00adef";
      } else if (name == "Flickr") {
        return "#ff0084";
      } else {
        return "secondary";
      }
    },
    validateUrl(url) {
      if (!url) return;
      let newUrl = window.decodeURIComponent(url);
      newUrl = newUrl.trim().replace(/\s/g, "");
      if (/^(:\/\/)/.test(newUrl)) {
        return `https${newUrl}`;
      }
      if (!/^(f|ht)tps?:\/\//i.test(newUrl)) {
        return `https://${newUrl}`;
      }
      return newUrl;
    },
    updateProfile() {
      var input = document.createElement('input');
      input.type = 'email';
      input.required = true;
      input.value = this.email.toLowerCase();
      if (!/\S+@\S+\.\S+/.test(this.email.toLowerCase())) {
        let payload2 = {
          snackBarText: `Given email address is not valid!`,
          snackBarColor: "error",
        };
        this.$store.dispatch("notify/setSnackbarMessage", payload2);
      } else {
        const payload = {
          oldEmail: this.details.user.email,
          newEmail: this.email,
          newName: this.name,
          password: this.password
        }
        CitySubApi.updateAccount(payload).then((res) => {
          console.log(res)
          Apicalls.getDetails({ email: this.email })
            .then((res) => {
              // console.log(res.data);
              this.details = res.data.content;
              this.isApiload = true;
              this.overlay = false;
              this.name = this.details.user.name;
              this.email = this.details.user.email;
              this.password = '';
            })
            .catch();
          this.dialog = false;
          let payload2 = {
            snackBarText: `Representative Account Updated!`,
            snackBarColor: "success",
          };
          this.$store.dispatch("notify/setSnackbarMessage", payload2);
        }).catch(() => {
          let payload2 = {
            snackBarText: `Something went wrong! \nPlease try again.`,
            snackBarColor: "error",
          };
          this.$store.dispatch("notify/setSnackbarMessage", payload2);
          this.dialog = false;
        });
      }
    }
  },
};
</script>
<style scoped>
.proof-link {
  cursor: pointer;
}

.cityDetailsContainer {
  min-height: 500px;
}
</style>
